import React from 'react';
import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import messages from './messages';
import { getRoleAndPermissions } from '../../utils/getRoleAndPermissions';
import { getFeatureToggle } from '../../utils/getFeatureToggle';
const getStaffDashboardMenu = () => {
  const {
    STUDIO_BASE_URL,
    COURSE_AUTHORING_MICROFRONTEND_URL,
    STAFF_DASHBOARD_URL,
    TAXONOMY
  } = getConfig();

  const {
    hasViewAnalytics,
    hasUserManagement,
    hasBillingView,
    hasPlatformSettings,
    hasNotificationSend,
    hasScheduleCreate,
    hasLibraryView,
    hasAiStudio
  } = getRoleAndPermissions();

  const { features_ai_course_creator, features_programs, features_video_library, features_document_library, features_team_management } = getFeatureToggle();

  let StaffDashboardMenu = [
    {
      icon: 'home-2',
      text: <FormattedMessage {...messages.home} />,
      href: STAFF_DASHBOARD_URL
    },
    {
      icon: 'book',
      text: <FormattedMessage {...messages.academics} />,
      children: [
        {
          text: <FormattedMessage {...messages.courses} />,
          href: STUDIO_BASE_URL + '/home'
        },
        ...(features_programs ? [{
          text: <FormattedMessage {...messages.programs} />,
          href: STAFF_DASHBOARD_URL + 'program'
        }] : []),
        ...(TAXONOMY ? [{
          text: <FormattedMessage {...messages.taxonomies} />,
          href: COURSE_AUTHORING_MICROFRONTEND_URL + '/taxonomies'
        }] : [])
      ]
    },
  ];

  if (hasLibraryView && (features_video_library || features_document_library)) {
    StaffDashboardMenu.push({
      icon: 'video',
      text: <FormattedMessage {...messages.library} />,
      href: STAFF_DASHBOARD_URL + (features_video_library ? 'library/videos' : 'library/documents')
    });
  }

  if (hasAiStudio && features_ai_course_creator) {
    StaffDashboardMenu.push({
      icon: 'ai-generate',
      iconSecondary: 'ai-generate-2',
      iconType: '',
      text: <FormattedMessage {...messages.aiStudio} />,
      href: STAFF_DASHBOARD_URL + 'ai-studio'
    });
  }

  StaffDashboardMenu.push(
    {
      icon: 'user',
      text: <FormattedMessage {...messages.users} />,
      children: hasUserManagement ? [
        {
          text: <FormattedMessage {...messages.allUsers} />,
          href: STAFF_DASHBOARD_URL + 'users'
        },
        {
          text: <FormattedMessage {...messages.staffs} />,
          href: STAFF_DASHBOARD_URL + 'staffs'
        },
        {
          text: <FormattedMessage {...messages.learners} />,
          href: STAFF_DASHBOARD_URL + 'learners'
        },
        ...(features_team_management ? [{
          text: <FormattedMessage {...messages.teams} />,
          href: STAFF_DASHBOARD_URL + 'teams'
        }] : [])
      ] : [
        {
          text: <FormattedMessage {...messages.learners} />,
          href: STAFF_DASHBOARD_URL + 'learners'
        }
      ]
    });

  if (hasViewAnalytics) {
    StaffDashboardMenu.push({
      icon: 'bar-chart',
      text: <FormattedMessage {...messages.analytics} />,
      href: STAFF_DASHBOARD_URL + 'analytics'
    });
  }

  if (hasScheduleCreate) {
    StaffDashboardMenu.push({
      icon: 'calendar',
      text: <FormattedMessage {...messages.schedule} />,
      href: STAFF_DASHBOARD_URL + 'calendar'
    });
  }

  if (hasNotificationSend) {
    StaffDashboardMenu.push({
      icon: 'lightbulb',
      text: <FormattedMessage {...messages.utilities} />,
      children: [
        {
          text: <FormattedMessage {...messages.notifications} />,
          href: STAFF_DASHBOARD_URL + 'utilities/notifications'
        },
      ]
    });
  }

  if (hasPlatformSettings) {
    StaffDashboardMenu.push({
      icon: 'settings-3',
      text: <FormattedMessage {...messages.platformSettings} />,
      children: [
        {
          text: <FormattedMessage {...messages.customization} />,
          href: STAFF_DASHBOARD_URL + 'platform-settings/customization'
        },
        {
          text: <FormattedMessage {...messages.integrations} />,
          href: STAFF_DASHBOARD_URL + 'platform-settings/integrations'
        },
        {
          text: <FormattedMessage {...messages.features} />,
          href: STAFF_DASHBOARD_URL + 'platform-settings/features'
        },

      ]
    });
  }

  if (hasBillingView) {
    StaffDashboardMenu.push({
      icon: 'currency',
      text: <FormattedMessage {...messages.billing} />,
      href: STAFF_DASHBOARD_URL + 'billing'
    });
  }

  const StaffDashboardFooter = [
    {
      icon: 'question',
      text: <FormattedMessage {...messages.support} />,
      href: STAFF_DASHBOARD_URL + 'support'
    }
  ]

  return { StaffDashboardMenu, StaffDashboardFooter };
};

export default getStaffDashboardMenu;
